import { Box } from "@mui/material";
import React from "react";

const COLORS = ["#fa114f", "#ffd54a", "#4eeccd", "#9d6bff", "#ff7a00", "#34c171"];

// Lightweight CSS confetti (no dependency). Rains inside its positioned parent.
const StreakConfetti = ({ count = 40 }) => {
  const pieces = Array.from({ length: count });
  return (
    <Box
      sx={{
        position: "absolute",
        inset: 0,
        overflow: "hidden",
        pointerEvents: "none",
        borderRadius: 4,
        zIndex: 0,
        "@keyframes confettiFall": {
          "0%": { transform: "translateY(-30px) rotate(0deg)", opacity: 0 },
          "10%": { opacity: 1 },
          "100%": { transform: "translateY(560px) rotate(720deg)", opacity: 0 },
        },
      }}
    >
      {pieces.map((_, i) => {
        const left = Math.random() * 100;
        const delay = Math.random() * 2.5;
        const dur = 2.6 + Math.random() * 2.4;
        const size = 6 + Math.random() * 6;
        const round = Math.random() > 0.5;
        return (
          <Box
            key={i}
            sx={{
              position: "absolute",
              top: 0,
              left: `${left}%`,
              width: `${size}px`,
              height: `${round ? size : size * 1.6}px`,
              background: COLORS[i % COLORS.length],
              borderRadius: round ? "50%" : "1px",
              animation: `confettiFall ${dur}s linear ${delay}s infinite`,
            }}
          />
        );
      })}
    </Box>
  );
};

export default StreakConfetti;
